<template>
  <div>
    <el-form
      label-position="top"
      ref="form"
      :rules="rules"
      :hide-required-asterisk="true"
      label-width="80px"
      :model="formLabelAlign"
    >
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="number">
            <div slot="label">
              <div class="label-text">
                課題編號
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-input
              placeholder="請輸入課題編號"
              v-model="formLabelAlign.number"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item prop="lang">
            <div slot="label">
              <div class="label-text">
                課程版本
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-select
              :disabled="isEdit"
              v-model="formLabelAlign.lang"
              placeholder="請選擇課程版本"
            >
              <el-option
                v-for="item in languages"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="24">
          <el-form-item label="描述">
            <el-input
              placeholder="請輸入描述"
              v-model="formLabelAlign.name"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <vue-dividing-line title="範圍及練習"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="" prop="scope">
            <div slot="label">
              <div class="label-text">
                課題範圍
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-select
              v-model="formLabelAlign.scope"
              placeholder="請選擇課題範圍"
            >
              <el-option
                v-for="item in newScope"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="" prop="gradeId">
            <div slot="label">
              <div class="label-text">
                年級
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-select
              v-model="formLabelAlign.gradeId"
              placeholder="請選擇年級"
            >
              <el-option
                v-for="(item, index) in grades"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
      </el-row>
      <el-form-item
        label=""
        :prop="`practises`"
        :rules="[{ required: true, type:'array', message: '請選擇練習', trigger: 'change' }]"
      >
      <div slot="label">
          <div class="label-text">
            練習
            <span class="star-mark">*</span>
          </div>
      </div>
      <draggable
          v-model="formLabelAlign.practises"
          animation="300"
          handle=".mover"
        >
          <el-row
            type="flex"
            align="middle"
            class="row-list"
            v-for="(items, index) in formLabelAlign.practises"
            :key="index"
            :gutter="10"
          >
            <el-col :span="6">
              <el-select
                value-key="id"
                v-model="formLabelAlign.practises[index]"
                filterable
                placeholder="請選擇練習"
              >
                <el-option
                  v-for="item in practises"
                  :key="item.id"
                  :label="item.number"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-input disabled v-model="items.desc" placeholder=""></el-input>
            </el-col>
            <el-col :span="1">
              <i
                v-if="formLabelAlign.practises.length &gt; 1"
                class="el-icon-rank mover"
              ></i>
            </el-col>
            <el-col :span="1">
              <i
                @click="onIconClose(index)"
                class="el-icon-close"
              ></i>
            </el-col>
          </el-row>
      </draggable>
      </el-form-item>
      <span
        class="plus-outline-add text-line-button cursor-pointer"
        @click="onAdd"
      >
        <i class="icon iconfont icon-jiahao" />添加更多練習
      </span>
      <vue-dividing-line title="小測"></vue-dividing-line>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label=""
            :prop="`smallTest.` + 'imageUrl'"
            :rules="[
              { required: true, message: '簡介圖片', trigger: 'change' },
            ]"
          >
            <div slot="label">
              <div class="label-text">
                簡介圖片
                <span class="star-mark">*</span>
              </div>
            </div>
            <upload
              @childByValue="childByValue"
              :imageurl="formLabelAlign.smallTest.imageUrl"
            ></upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="page-row-list">
        <el-col :span="6">
          <div class="label-text">
            練習
            <span class="star-mark">*</span>
          </div></el-col
        >
        <el-col :span="6">
          <div class="label-text">
            隨機抽取
            <span class="star-mark">*</span>
          </div></el-col
        >
      </el-row>
      <draggable
        v-model="formLabelAlign.smallTest.practises"
        animation="300"
        handle=".moverPractises"
      >
        <el-row
          :gutter="20"
          type="flex"
          align="middle"
          class="row-list"
          v-for="(item, index) in formLabelAlign.smallTest.practises"
          :key="index"
        >
          <el-col :span="6">
            <el-form-item
              label=""
              :prop="`smallTest.practises.` + index + '.number'"
              :rules="[
                { required: true, message: '請選擇練習', trigger: 'blur' },
              ]"
            >
              <el-select
                value-key="number"
                filterable
                v-model="item.number"
                @change="onSmallTestNumber(item.number, index)"
                placeholder="請選擇練習"
              >
                <el-option
                  v-for="item in practises"
                  :key="item.number"
                  :label="item.number"
                  :value="item"
                >
                </el-option>
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item
              label=""
              :prop="`smallTest.practises.` + index + '.randomNumber'"
              :rules="[
                {
                  required: true,
                  message: '請輸入隨機抽取數量',
                  trigger: 'blur',
                },
                {
                  pattern: /^[0-9]*$/,
                  message: '请輸入纯數字',
                  trigger: 'blur',
                },  
              ]"
            >
              <el-input
                placeholder="請輸入隨機抽取數量"
                v-model.number="item.randomNumber"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="1">
            <i
              v-if="formLabelAlign.smallTest.practises.length &gt; 1"
              class="el-icon-rank moverPractises"
            ></i>
          </el-col>
          <el-col :span="1" @click.native="onClose(index)">
            <i
              v-if="formLabelAlign.smallTest.practises.length &gt; 1"
              class="el-icon-close"
            ></i>
          </el-col>
        </el-row>
      </draggable>
      <span
        class="plus-outline-add text-line-button cursor-pointer"
        @click="onAddSubject"
      >
        <i class="icon iconfont icon-jiahao" />添加更多題目
      </span>
    </el-form>
  </div>
</template>

<script>
import {getGrades} from '@/api/grade'
import { getPractises } from "@/api/practises";
import upload from "@/components/upload";
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
    upload,
  },
  props: {
    formLabelAlign: {
      type: Object,
      default: function () {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "formLabelAlign.lang": {
      handler() {
        this.getPractises();
      },
      deep: true,
    },
  },
  computed: {
    newScope(){
      return  this.scope 
      // return this.formLabelAlign.lang == 0 ? this.scope : this.scopeEn
    }
  },
  created() {
    this.getPractises();
    this.getGrades();
  },
  data() {
    return {
      grades: [],
      practises: [],
      rules: {
        number: [
          { required: true, message: "請輸入課題編號", trigger: "blur" },
        ],
        lang: [{ required: true, message: "請選擇課程版本", trigger: "change" }],
        scope: [{ required: true, message: "請選擇課題範圍", trigger: "blur" }],
        gradeId: [{ required: true, message: "請選擇年級", trigger: "blur" }],
      },
    };
  },
  methods: {
    getGrades(){
      getGrades().then((res)=>{
         this.grades = res.data
      })
    },
    onSmallTestNumber(value, index) {
      this.formLabelAlign.smallTest.practises[index].number = value.number;
      this.formLabelAlign.smallTest.practises[index].id = value.id;
    },
    onPractisesChange(index, item) {
      this.formLabelAlign.practises[index] = item;
      this.$forceUpdate();
    },
    childByValue(value) {
      this.formLabelAlign.smallTest.imageUrl = value;
      this.$forceUpdate();
    },
    onIconClose(index) {
      this.formLabelAlign.practises.splice(index, 1);
      this.$forceUpdate();
    },
    onClose(index) {
      this.formLabelAlign.smallTest.practises.splice(index, 1);
      this.$forceUpdate();
    },
    onAdd() {
      let value = {
        number: null,
        id: null,
        desc: "",
      };
      this.formLabelAlign.practises.push(value);
    },
    onAddSubject() {
      let value = {
        id: "",
        number: "",
        randomNumber: "",
      };
      this.formLabelAlign.smallTest.practises.push(value);
      this.$forceUpdate();
    },
    getPractises() {
      let from = {
        lang: this.formLabelAlign.lang,
      };
      getPractises(from).then((v) => {
        this.practises = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.row-list{
  margin-bottom: 20px;
}
.page-row-list{
  margin-top: 20px;
}
::v-deep {
  .el-select {
    width: 100%;
  }
  .el-form-item{
    margin-bottom: 0;
  }
}
</style>